import React, {useEffect, useRef} from 'react';

type Props = {
    value           : string
    placeholder?    : string
    onChange        : callback
    className?      : string
    size?           : 30 | 36
}

export default function SearchInput(props: Props) {

    const searchInputRef = useRef<HTMLInputElement>(null);

    const onChange = (e:React.ChangeEvent<HTMLInputElement>) => {
        props.onChange(e.target.value);
    };

    const onReset = ()=>{
        props.onChange("")
    }

    const classes = Classes("gd-search", props.className,{
        'size-36'       : props.size === 36
    })

    useEffect(()=>{
        searchInputRef.current?.focus()
    }, [])

    return (
        <div className={classes}>
            <input ref          = {searchInputRef}
                   type         = "input"
                   value        = {props.value ? props.value : ''}
                   onChange     = {onChange}
                   placeholder  = {props.placeholder || 'Search'} />

            <div className="i5-search" />

            {/*{!!props.value &&*/}
            {/*    <div className="i5-delete" onClick={onReset}> </div>*/}
            {/*}*/}

            {!!props.value &&
                <div className="btn-delete i5-delete-circle-solid fs-16" onClick={onReset} />
            }
        </div>
    );
}
